module.exports = require("@wildboar/x500/src/lib/modules/DSAOperationalAttributeTypes/ditBridgeKnowledge.oa");